import React from 'react';
import { FieldArray, Formik } from 'formik';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Grid, IconButton } from '@mui/material';
import { TextField } from '@qrios/frontend-library';
import * as Yup from 'yup';
import { Params } from '../interfaces';
import { transformParamsToArray } from './interfaces';

interface Props {
  params: Params;
  onSubmit: (params: Params) => void;
  handleClose: () => void;
}

const validationSchema = Yup.object({
  params: Yup.array().of(
    Yup.object().shape({
      key: Yup.string().required('Key is required'),
      value: Yup.string().required('Value is required')
    })
  )
});

interface NewParams {
  [key: string]: string;
}

const ProcessEditor = ({ params, onSubmit, handleClose }: Props) => {
  const transformArrayToParams = (array: NewParams[]) =>
    array.reduce((acc, { key, value }) => {
      acc[key] = value;
      return acc;
    }, {}) as Params;

  return (
    <Formik
      initialValues={{
        params: transformParamsToArray(params) || []
      }}
      validationSchema={validationSchema}
      onSubmit={values => {
        const transformedValues = transformArrayToParams(values.params as NewParams[]);
        onSubmit(transformedValues);
      }}
    >
      {({ handleSubmit, values, handleChange, errors, touched, handleBlur }) => (
        <FieldArray
          name="params"
          render={({ insert, remove }) => (
            <Grid container spacing={2}>
              {values.params.length === 0 ? (
                <div>No process parameters defined</div>
              ) : (
                values.params.map((param, index) => (
                  <Grid container key={index} spacing={2}>
                    <Grid item xs={1}>
                      <></>
                    </Grid>
                    <Grid item xs={5}>
                      <TextField
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        name={`params[${index}].key`}
                        label=""
                        placeholder="Enter key"
                        value={param.key}
                        // @ts-ignore
                        error={errors.params?.[index]?.key}
                        touched={touched.params?.[index]?.key}
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <TextField
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        name={`params[${index}].value`}
                        label=""
                        placeholder="Enter value"
                        value={param.value}
                        // @ts-ignore
                        error={errors.params?.[index]?.value}
                        touched={touched.params?.[index]?.value}
                      />
                    </Grid>
                    <Grid item style={{ marginTop: '7px' }} xs={1}>
                      <IconButton aria-label="delete" size="large" onClick={() => remove(index)}>
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                ))
              )}
              <Grid container item xs={12} spacing={0} alignItems="center" justifyContent="end">
                <Button
                  endIcon={<AddIcon />}
                  onClick={() =>
                    insert(values.params.length, {
                      key: '',
                      value: ''
                    })
                  }
                >
                  Add Next Parameter
                </Button>
              </Grid>
              <Grid container item xs={12} spacing={0} alignItems="center" justifyContent="end">
                <Box>
                  <Button onClick={handleClose}>Cancel</Button>
                </Box>
                <Box>
                  <Button onClick={() => handleSubmit()}>Apply</Button>
                </Box>
              </Grid>
            </Grid>
          )}
        />
      )}
    </Formik>
  );
};

export default ProcessEditor;
